/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Success_TitleInputs */



/**
* | output |
* | --- |
* | "Thanks for your feedback!" |
*
* @param {Feedback_Success_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_success_title = /** @type {((inputs?: Feedback_Success_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Success_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Merci pour votre retour !")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Gracias por su comentario!")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Obrigado pelo seu feedback!")
	if (locale === "it") return /** @type {LocalizedString} */ ("Grazie per il tuo feedback!")
	return /** @type {LocalizedString} */ ("Thanks for your feedback!")
});